export default __webpack_public_path__ + "static/media/blessedsacrament.186d03e2.jpg";